package io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.icons

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.Icons

public val Icons.PersonAddW500Rounded: ImageVector
    get() {
        if (_personAddW500Rounded != null) {
            return _personAddW500Rounded!!
        }
        _personAddW500Rounded = Builder(name = "PersonAddW500Rounded", defaultWidth = 24.0.dp, defaultHeight = 24.0.dp, viewportWidth = 960.0f, viewportHeight = 960.0f).apply {
            path(fill = SolidColor(Color(0xFF000000)), stroke = null, strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f, pathFillType = NonZero) {
                moveTo(724.3f, 431.63f)
                horizontalLineToRelative(-76.17f)
                quadToRelative(-17.81f, 0.0f, -29.86f, -12.1f)
                reflectiveQuadToRelative(-12.05f, -29.81f)
                quadToRelative(0.0f, -17.72f, 12.05f, -29.82f)
                quadToRelative(12.05f, -12.1f, 29.86f, -12.1f)
                horizontalLineToRelative(76.17f)
                verticalLineToRelative(-76.17f)
                quadToRelative(0.0f, -17.81f, 12.1f, -29.86f)
                reflectiveQuadToRelative(29.82f, -12.05f)
                quadToRelative(17.71f, 0.0f, 29.81f, 12.05f)
                quadToRelative(12.1f, 12.05f, 12.1f, 29.86f)
                verticalLineToRelative(76.17f)
                horizontalLineToRelative(76.17f)
                quadToRelative(17.82f, 0.0f, 29.87f, 12.1f)
                reflectiveQuadToRelative(12.05f, 29.82f)
                quadToRelative(0.0f, 17.71f, -12.05f, 29.81f)
                quadToRelative(-12.05f, 12.1f, -29.87f, 12.1f)
                horizontalLineToRelative(-76.17f)
                verticalLineToRelative(76.17f)
                quadToRelative(0.0f, 17.82f, -12.1f, 29.87f)
                reflectiveQuadToRelative(-29.81f, 12.05f)
                quadToRelative(-17.72f, 0.0f, -29.82f, -12.05f)
                quadToRelative(-12.1f, -12.05f, -12.1f, -29.87f)
                verticalLineToRelative(-76.17f)
                close()
                moveTo(241.86f, 426.66f)
                quadToRelative(-49.27f, -49.27f, -49.27f, -118.86f)
                quadToRelative(0.0f, -69.58f, 49.27f, -118.74f)
                quadToRelative(49.27f, -49.15f, 118.86f, -49.15f)
                quadToRelative(69.58f, 0.0f, 118.86f, 49.15f)
                quadToRelative(49.27f, 49.16f, 49.27f, 118.74f)
                quadToRelative(0.0f, 69.59f, -49.27f, 118.86f)
                quadToRelative(-49.28f, 49.27f, -118.86f, 49.27f)
                quadToRelative(-69.59f, 0.0f, -118.86f, -49.27f)
                close()
                moveTo(32.59f, 721.2f)
                verticalLineToRelative(-29.61f)
                quadToRelative(0.0f, -36.23f, 18.74f, -66.59f)
                quadToRelative(18.74f, -30.37f, 49.8f, -46.35f)
                quadToRelative(62.72f, -31.24f, 127.66f, -46.98f)
                quadToRelative(64.95f, -15.74f, 131.93f, -15.74f)
                quadToRelative(67.43f, 0.0f, 132.39f, 15.62f)
                quadToRelative(64.96f, 15.62f, 127.19f, 46.86f)
                quadToRelative(31.06f, 15.95f, 49.81f, 46.25f)
                quadToRelative(18.74f, 30.3f, 18.74f, 66.93f)
                verticalLineToRelative(29.61f)
                quadToRelative(0.0f, 37.78f, -26.61f, 64.39f)
                reflectiveQuadToRelative(-64.39f, 26.61f)
                lineTo(123.59f, 812.2f)
                quadToRelative(-37.79f, 0.0f, -64.39f, -26.61f)
                quadToRelative(-26.61f, -26.61f, -26.61f, -64.39f)
                close()
                moveTo(123.59f, 721.2f)
                horizontalLineToRelative(474.26f)
                verticalLineToRelative(-28.42f)
                quadToRelative(0.0f, -10.77f, -5.5f, -19.58f)
                quadToRelative(-5.5f, -8.81f, -14.5f, -13.7f)
                quadToRelative(-52.57f, -26.04f, -106.85f, -39.3f)
                quadToRelative(-54.28f, -13.27f, -110.28f, -13.27f)
                quadToRelative(-55.52f, 0.0f, -110.29f, 13.27f)
                quadToRelative(-54.76f, 13.26f, -106.84f, 39.3f)
                quadToRelative(-9.0f, 4.89f, -14.5f, 13.7f)
                quadToRelative(-5.5f, 8.81f, -5.5f, 19.58f)
                verticalLineToRelative(28.42f)
                close()
                moveTo(415.18f, 362.28f)
                quadToRelative(22.67f, -22.65f, 22.67f, -54.47f)
                quadToRelative(0.0f, -31.81f, -22.66f, -54.35f)
                quadToRelative(-22.65f, -22.55f, -54.46f, -22.55f)
                quadToRelative(-31.82f, 0.0f, -54.48f, 22.55f)
                quadToRelative(-22.66f, 22.54f, -22.66f, 54.35f)
                quadToRelative(0.0f, 31.82f, 22.65f, 54.47f)
                quadToRelative(22.66f, 22.65f, 54.47f, 22.65f)
                reflectiveQuadToRelative(54.47f, -22.65f)
                close()
                moveTo(360.72f, 307.8f)
                close()
                moveTo(360.72f, 721.2f)
                close()
            }
        }
        .build()
        return _personAddW500Rounded!!
    }

private var _personAddW500Rounded: ImageVector? = null
